module.exports = __webpack_public_path__ + "img/2161.aafc33fd.gif";